
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ChatTheme } from "@/types/theme";
import { useToast } from "@/components/ui/use-toast";
import { prepareThemeForDatabase } from "@/utils/themeUtils";

export const useThemeMutations = (id: string | undefined) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const updateTheme = useMutation({
    mutationFn: async (updates: Partial<ChatTheme> | any) => {
      if (!id) throw new Error("No chatbot ID provided");
      
      // Use utility function to prepare theme data for database
      const dbUpdates = prepareThemeForDatabase(updates);
      
      console.log("Updating theme with:", dbUpdates);
      
      const { error } = await supabase
        .from("themes")
        .update(dbUpdates)
        .eq("chatbot_id", id);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["theme", id] });
      toast({
        title: "Theme updated",
        description: "Your chatbot theme has been updated successfully.",
      });
    },
    onError: (error: any) => {
      console.error("Theme update error:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to update theme",
      });
    },
  });

  return { updateTheme };
};
